// extracted by mini-css-extract-plugin
export default {"doctor_listing_modal_align":"BookAppointment_doctor_listing_modal_align__PJAhs","doctor_listing_heading":"BookAppointment_doctor_listing_heading__17ZW-"};